import { Controller } from "@hotwired/stimulus"

// Usage: data-controller="tabs"
// data-tabs-active-value="description" (optionnel, valeur par défaut)
// data-action="click->tabs#show"

export default class extends Controller {
  static values = { active: String }
  static targets = ["tab", "panel"]

  connect() {
    this.showActiveTab()
  }

  show(event) {
    const tab = event.currentTarget
    const tabName = tab.getAttribute("data-tab")
    this.activeValue = tabName
    this.showActiveTab()
  }

  showActiveTab() {
    const activeClasses = ["bg-white", "text-indigo-700", "shadow-sm"]
    const inactiveClasses = ["text-indigo-400", "hover:text-indigo-600"]
    this.tabTargets.forEach(tab => {
      const tabName = tab.getAttribute("data-tab")
      tab.classList.remove(...activeClasses, ...inactiveClasses)
      if (tabName === this.activeValue) {
        tab.classList.add(...activeClasses)
      } else {
        tab.classList.add(...inactiveClasses)
      }
    })
    this.panelTargets.forEach(panel => {
      const panelName = panel.getAttribute("data-panel")
      panel.style.display = (panelName === this.activeValue) ? "block" : "none"
    })
  }
}
